<template>
  <div id="app">
    <!-- Bewusst ohne "Später": der Hinweis bleibt, bis neu geladen wird -->
    <div v-if="updateVerfuegbar" class="update-hinweis alert alert-warning mb-0 rounded-0 text-center" role="alert">
      Es gibt eine neue Version des Intranets. Bitte speichern Sie offene Eingaben und laden Sie die Seite anschließend neu.
      <b-button size="sm" variant="primary" class="ml-3" @click="neuLaden">Neu laden</b-button>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    updateVerfuegbar() {
      return this.$store.state.updateVerfuegbar;
    },
  },
  methods: {
    neuLaden() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
@import "./styles/app.scss";

.update-hinweis {
  position: sticky;
  top: 0;
  z-index: 1100;
}

@media print {
  .update-hinweis {
    display: none;
  }
}
</style>
